/**
 * Page-owned report layouts use a single canonical key in layout state.
 * The flattened `page.layout` contract means the page itself owns that layout.
 */
export function deriveLayoutIdForPage(pageId: string): string {
	return pageId.trim();
}

/**
 * Normalizes any external page-owned layout id onto the canonical page key.
 * Legacy callers may still send values like `layout_${pageId}`.
 */
export function normalizePageOwnedLayoutId(
	pageId: string,
	_layoutId?: string | null
): string {
	return deriveLayoutIdForPage(pageId);
}
